import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import SwiperCore, {
  Navigation
} from 'swiper/core'

import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'

import './styles.scss'
import { getCart, updateInCart } from '../../store/modules/cart/actions'
import CartItemPopin from '../../../shared/components/molecules/CartItemPopin'
import {
  updateMiniCartCount,
  retrieveRecommendedProducts
} from '../../utils/helpers'
import RecommendedProductPopin from '../../components/atoms/RecommendedProductPopin'
import { isMobile } from '../../../shared/helpers/babHelpers'

export default function PopinCart ({
  products,
  freeGiftsSelectionAvailable,
  secondStepGiftsAvailable,
  availableSamples,
  samplesSettingTypesSkus
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart)
  const [productId, setProductId] = useState(null)
  const [currentProduct, setCurrentProduct] = useState(null)
  const [recommendedProducts, setRecommendedProducts] = useState([])
  const [addedRecommendedProducts, setAddedRecommendedProducts] = useState([])
  const [animatedProduct, setAnimatedProduct] = useState(null)

  SwiperCore.use([Navigation])

  useEffect(() => {
    window.addEventListener('launchIncentiveCartPopin', event => {
      console.log('launchIncentiveCartPopin received', event.detail.variantId)
      dispatch(getCart())
      setProductId(event.detail.variantId)
      openModal()
    })
  }, [])

  useEffect(() => {
    if (products.length > 0 && currentProduct) {
      setRecommendedProducts(retrieveRecommendedProducts(currentProduct, products))
    }
  }, [currentProduct])

  useEffect(() => {
    if (cart && productId) {
      setCurrentProduct(cart.items.find(item => item.id === Number(productId)))
      updateMiniCartCount(cart)
    }

    if (animatedProduct) {
      if (addedRecommendedProducts?.filter(item => item.sku === animatedProduct.sku).length === 0) {
        setAddedRecommendedProducts(current => [...current, cart.items.find(item => item.sku === animatedProduct.sku)])
      }
      setTimeout(function () {
        setAnimatedProduct(null)
        if (document.getElementById('chat-button')) document.getElementById('chat-button').style.display = 'none'
        if (document.getElementById('launcher')) document.getElementById('launcher').style.display = 'none'
        document.querySelector(`div[data-sku="${animatedProduct.sku}"]`).style.display = 'none'
      }, 2000)
    }

    const productToRemove = addedRecommendedProducts?.find(item => item.quantity === 0)
    const recommendedProductsLeft = addedRecommendedProducts?.filter(item => item.quantity !== 0)
    if (productToRemove) {
      setAddedRecommendedProducts(recommendedProductsLeft)
      document.querySelector(`div[data-sku="${productToRemove.sku}"]`).style.display = 'flex'
    }
  }, [cart.item_count])

  const closeModal = () => {
    document.querySelector('#incentive-cart-popin').style.display = 'none'
  }

  const openModal = () => {
    document.querySelector('#incentive-cart-popin').style.display = 'flex'
  }

  const addProductToCart = product => {
    setAnimatedProduct(product)
    dispatch(updateInCart(product, product.quantity + 1))
  }

  const goToCart = () => {
    if (recommendedProducts.length > 0) {
      recommendedProducts.map((recommendedProduct, i) => {
        document.querySelector(`div[data-sku="${recommendedProduct.sku}"]`).style.display = 'flex'
      })
    }
    closeModal()
    document.getElementById('incentive-cart-slide').style.display = 'block'
    if (document.getElementById('chat-button')) document.getElementById('chat-button').style.display = 'none'
    if (document.getElementById('launcher')) document.getElementById('launcher').style.display = 'none'
    setAddedRecommendedProducts([])
  }

  const totalPrice = Number(cart.total_price / 100).toFixed(2).replace('.', ',')

  return (
    <div id='incentive-cart-popin' className='slide-cart-overlay'>
      <div className='incentive-cart-popin'>
        <div className='cart-popin-container'>
          {isMobile() &&
            <div onClick={closeModal} className='cart-popin-close'>
              <div className='popin-border' />
              <img id='popin-cross' src='https://cdn.shopify.com/s/files/1/1956/4693/files/cross.png?v=1678704500' />
            </div>}

          {!isMobile() &&
            <div onClick={closeModal} className='cart-popin-close'>
              <img id='popin-ellipse' src='https://cdn.shopify.com/s/files/1/1956/4693/files/ellipse_cross.png?v=1678703993' />
            </div>}

          {!isMobile() && <div className='popin-close-area' />}

          <div className='cart-popin-product-section'>
            <div className='cart-popin-img'>
              <img id='bird-img' alt='bird' src='https://cdn.shopify.com/s/files/1/1956/4693/files/bird.png?v=1678378597' />
            </div>

            <div className='cart-popin-title'>{t('popinCart:title')}</div>

            {<div className='cart-popin-content'>
              {currentProduct
                ? <CartItemPopin updateInCart={updateInCart} item={currentProduct} />
                : <div className='cart-popin-no-product'>{t('popinCart:noProduct')}</div>}

              {addedRecommendedProducts?.length > 0 &&
              <>
                {addedRecommendedProducts.map((addedRecommendedProduct, i) =>
                  <CartItemPopin
                    updateInCart={updateInCart}
                    item={addedRecommendedProduct}
                    addedRecommendedProducts={addedRecommendedProducts}
                    key={i}
                  />
                )}
              </>}
            </div>}

            {!isMobile() &&
              <div className='cart-popin-ctas'>
                <button type='submit' className='product-button joone-button'>
                  <p className='cart-cta' onClick={goToCart}> {t('popinCart:cartButton')} -
                    <span> {t('general:dynamicPrice', { price: totalPrice })}</span>
                  </p>
                </button>
              </div>}
          </div>

          {!isMobile() &&
            <div className='block-separator'>
              <div className='separator' />
            </div>}

          <div className='cart-popin-upsell'>
            {recommendedProducts?.length > 0 &&
              <>
                <div className='recommended-products-text'>{t('popinCart:recommendedProducts')}</div>
                <p className='recommended-products-text-infos'>({t('popinCart:recommendedProductsInfos')})</p>
                <div className='recommended-products-container'>
                  {recommendedProducts.map((recommendedProduct, i) =>
                    <RecommendedProductPopin
                      recommendedProduct={recommendedProduct}
                      onClick={addProductToCart}
                      animatedProduct={animatedProduct && recommendedProduct.sku === animatedProduct.sku}
                      key={i}
                    />
                  )}
                </div>
              </>}
          </div>

          {isMobile() &&
            <div className='cart-popin-footer'>
              <button type='submit' className='product-button joone-button'>
                <p className='cart-cta' onClick={goToCart}> {t('popinCart:cartButton')} -
                  <span> {t('general:dynamicPrice', { price: totalPrice })}</span>
                </p>
              </button>
            </div>}

        </div>
      </div>
    </div>
  )
}
